import { assertEnabledAPI } from './assertEnabledAPI';
export class EssentialsPartialGetters {
    getExperiments(fallback) {
        const experiments = this.experiments ?? fallback?.experiments;
        assertEnabledAPI(experiments, 'Experiments were used without being correctly initialized! Make sure you pass `{ experiments: { scopes: [...] } }` to the `createEssentials` function.');
        return experiments;
    }
    getFedopsLogger(fallback) {
        const fedopsLogger = this.fedopsLogger ?? fallback?.fedopsLogger;
        assertEnabledAPI(fedopsLogger, "Fedops was used without being correctly initialized! Make sure you pass`{ fedops: { appName: '...' } }` to the `createEssentials` function.");
        return fedopsLogger;
    }
    getErrorMonitor(fallback) {
        const errorMonitor = this.errorMonitor ?? fallback?.errorMonitor;
        assertEnabledAPI(errorMonitor, 'ErrorMonitor was used without being correctly initialized! Make sure you pass `{ errorMonitor: { ... } }` to the `createEssentials` function.');
        return errorMonitor;
    }
    getI18n(fallback) {
        const _i18n = this.i18n ?? fallback?.i18n;
        assertEnabledAPI(_i18n, 'i18n was used without being correctly initialized! Make sure you pass `{ i18n: { ... } }` to the `createEssentials` function.');
        return _i18n;
    }
    getBILoggerFactory(fallback) {
        const biLoggerFactory = this.biLoggerFactory ?? fallback?.biLoggerFactory;
        assertEnabledAPI(biLoggerFactory, 'BILoggerFactory was not initialized');
        return biLoggerFactory;
    }
    getBILogger(fallback) {
        const biLogger = this.biLogger ?? fallback?.biLogger;
        assertEnabledAPI(biLogger, 'BILogger was not initialized');
        return biLogger;
    }
    getHttpClient(fallback) {
        const httpClient = this.httpClient ?? fallback?.httpClient;
        assertEnabledAPI(httpClient, 'HttpClient was not initialized');
        return httpClient;
    }
    getEnvironment(fallback) {
        const environment = fallback?.environment;
        assertEnabledAPI(environment, 'Environment was not initialized');
        return environment;
    }
    getErrorHandler(fallback) {
        const errorHandler = fallback?.errorHandler;
        assertEnabledAPI(errorHandler, 'ErrorHandler was not initialized');
        return errorHandler;
    }
    getDataCapsule(fallback) {
        const dataCapsule = this.dataCapsule ?? fallback?.dataCapsule;
        assertEnabledAPI(dataCapsule, 'DataCapsule was used without being correctly initialized! Make sure you pass `{ dataCapsule: { ... } }` to the `createEssentials` function.');
        return dataCapsule;
    }
    getCreateCurrencyFormatter(fallback) {
        const createCurrencyFormatter = this.createCurrencyFormatter ?? fallback?.createCurrencyFormatter;
        assertEnabledAPI(createCurrencyFormatter, 'CreateCurrencyFormatter was not initialized');
        return createCurrencyFormatter;
    }
    getFormatAddress(fallback) {
        const formatAddress = this.formatAddress ?? fallback?.formatAddress;
        assertEnabledAPI(formatAddress, 'formatAddress was not initialized');
        return formatAddress;
    }
    getAbTranslate(fallback) {
        const abTranslate = this.abTranslate ?? fallback?.abTranslate;
        assertEnabledAPI(abTranslate, 'abTranslate was not initialized');
        return abTranslate;
    }
    getPanoramaClient(fallback) {
        const panoramaClient = this.panoramaClient ?? fallback?.panoramaClient;
        assertEnabledAPI(panoramaClient, 'panoramaClient was not initialized');
        return panoramaClient;
    }
}
//# sourceMappingURL=EssentialsPartialGetters.js.map